import React from 'react';
import { Stack, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import LinearProgress from '@mui/material/LinearProgress';

// ************************************************************

const ECU_PREFIXES = [
  "MP32_PLUS",
  "MP48_PLUS",
  "MP60_PLUS",
]

export default function EcuFwResellerFormDialog(props) {
   
  const [formData, setFormData] = React.useState({
    ecu_prefix: '',
    country_code: '',
    reseller_id: -1,
    fw_name: '',
    note: '',
  })

  React.useEffect(() => {
    if (props.editRow) {
      setFormData({
        ecu_prefix: props.editRow.ecu_prefix || '',
        country_code: props.editRow.country_code || '',
        reseller_id: props.editRow.reseller_id !== undefined ? props.editRow.reseller_id : -1,
        fw_name: props.editRow.fw_name || '',
        note: props.editRow.note || '',
      })
    } else {
      setFormData({
        ecu_prefix: '',
        country_code: '',
        reseller_id: -1,
        fw_name: '',
        note: '',
      })
    }
  }, [props.editRow, props.open])

  const handleClose = () => {
    props.onClickClose()
  }
  const handleSubmit = () => {
    if (props.editRow) {
      props.onClickSubmit({ id: props.editRow.id, ...formData })
    } else {
      props.onClickSubmit(formData)
    }
  }
  const handleTextBoxChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }))
  }  
  const handleSelectChange = (name) => (e) => {
    setFormData(prev => ({ ...prev, [name]: e.target.value }))
  }

  var view_en = {
    cancel_button: true,
    submit_button: true,
    show_spin: false,
  }  
  if (props.spin) {
    view_en.cancel_button = false
    view_en.submit_button = false
    view_en.show_spin = true
  }
    
  const isEdit = !!props.editRow

  return (    
    <div>      
      <Dialog 
        maxWidth='sm'
        fullWidth={true}
        open={props.open} 
      >
        <DialogTitle>{isEdit ? 'EDIT FW RESELLER' : 'ADD FW RESELLER'}</DialogTitle>
        <DialogContent>
          <Stack spacing={3}>
              <FormControl fullWidth margin="dense" variant="standard" disabled={view_en.show_spin}>
                <InputLabel>ECU Prefix *</InputLabel>
                <Select
                  value={formData.ecu_prefix}
                  onChange={handleSelectChange('ecu_prefix')}
                >
                  {ECU_PREFIXES.map(p => (
                    <MenuItem key={p} value={p}>{p}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                value={formData.country_code}
                margin="dense"
                name="country_code"
                label="Country Code (e.g. ITA, DEU - empty = any)"
                onChange={handleTextBoxChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <FormControl fullWidth margin="dense" variant="standard" disabled={view_en.show_spin}>
                <InputLabel>Reseller (-1 = any)</InputLabel>
                <Select
                  value={formData.reseller_id}
                  onChange={handleSelectChange('reseller_id')}
                >
                  <MenuItem value={-1}>ANY (default)</MenuItem>
                  {(props.resellersRows || []).map(row => (
                    <MenuItem key={row.id} value={row.id}>{row.view_text}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                value={formData.fw_name}
                margin="dense"
                name="fw_name"
                label="FW Name (e.g. MP32_PLUS-009-0020) *"
                onChange={handleTextBoxChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
              <TextField
                value={formData.note}
                margin="dense"
                name="note"
                label="Note"
                onChange={handleTextBoxChange}
                type="text"
                fullWidth
                variant="standard"
                disabled={view_en.show_spin}
                />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={!view_en.cancel_button} onClick={handleClose}>Cancel</Button>
          <Button disabled={!view_en.submit_button} onClick={handleSubmit}>{isEdit ? 'Update' : 'Create'}</Button>
        </DialogActions>
        {view_en.show_spin && <LinearProgress />}
      </Dialog>
    </div>
  );
}
